import {Component, ElementRef, Inject, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ProgressService} from '../../../service/progress.service';
import {BaseModalComponent} from '../base-modal/base-modal.component';

export interface TimeData {
  serverTime: Date;
}

@Component({
  selector: 'client-time-shift-modal',
  templateUrl: './client-time-shift.component.html',
  styleUrls: ['./client-time-shift.component.scss']
})
export class ClientTimeShiftComponent extends BaseModalComponent {

  serverTime: Date;
  clientTime: Date;

  @ViewChild('dialogContent', {static: true}) protected progressContainer!: ElementRef;

  constructor(dialogRef: MatDialogRef<ClientTimeShiftComponent>,
              progressService: ProgressService,
              @Inject(MAT_DIALOG_DATA) data: TimeData) {
    super(dialogRef, progressService);

    this.serverTime = data.serverTime;
    this.clientTime = new Date();
  }

  proceed(): void {
    this.closeModal();
  }

  proceedAllowed(): boolean {
    return true;
  }
}
